import React from "react";
import "./styles.css";
import { Images } from "../../theme";

export default function ProductCard(props) {
  let { daily_price, firstname, location, images, lastname, rating, title } =
    props.data;
  return (
    <>
      <div className="smallCart">
        <img
          style={{ width: "100%", borderRadius: 12 }}
          src={
            images.length ? `${props.imageUrl}${images[0]}` : Images.productImg
          }
          alt="image"
        />
        <p className="tagName mb-0">
          {firstname} {lastname}
        </p>
        <p className="productNameHeading">{title}</p>
        <div>
          <img
            className="locationIconSmall"
            src={Images.locationIcon}
            alt="image"
          />
          <span className="locationSmallText">{location}</span>
        </div>
        <div className="ratingStyle">
          <span className="productNamePrice">${daily_price}</span>
          <p className="ratingSmallTextR">{rating ? rating : 0}</p>
          <img
            className="ratingIconSmall"
            src={Images.ratingIcon}
            alt="image"
          />
        </div>
      </div>
    </>
  );
}
